import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../common/constants/urls';

import { type AddIncomingCallParams, type ListResponse } from './types';

export const getList = ({
	page,
}: {
	page: number;
}): Promise<{ count: number; data: ListResponse }> => {
	const limit = 20;
	const offset = (page - 1) * limit;
	const params = new URLSearchParams({
		offset: `${offset}`,
		limit: `${limit}`,
		sortBy: 'name',
		sort: 'asc',
	});

	const endpoint = `${urls.incomingCall.url()}?${params.toString()}`;

	return fetch<{ count: number; data: ListResponse }>(endpoint).then(({ data, count }) => {
		return {
			data,
			count: Math.ceil(count / limit),
		};
	});
};

export const addIncomingCall = (params: AddIncomingCallParams): Promise<{ id: string }> => {
	return fetch(urls.incomingCall.url(), {
		method: 'POST',
		body: params,
	});
};
